import React from 'react';
import ReportingFinancesLineItemsPage from '../components/ReportingFinancesLineItemsPage';

const ReportingFinancesLineItemsApp = (props) => (
  <ReportingFinancesLineItemsPage {...props} />
);

export default ReportingFinancesLineItemsApp;
